var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row logo"},[_c('img',{staticClass:"ma-8",staticStyle:{"height":"30px","width":"auto"},attrs:{"alt":"logo","src":require("../../../assets/aprocon_logo-30.png")}})])
}]

export { render, staticRenderFns }